import { render, staticRenderFns } from "./specialCatalogueSearchBar.vue?vue&type=template&id=35c9c8e9&scoped=true"
import script from "./specialCatalogueSearchBar.vue?vue&type=script&lang=js"
export * from "./specialCatalogueSearchBar.vue?vue&type=script&lang=js"
import style0 from "./specialCatalogueSearchBar.vue?vue&type=style&index=0&id=35c9c8e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c9c8e9",
  null
  
)

export default component.exports